<template>
  <!-- component container -->
  <div class="kpi-grid" :class="[isGrow ? 'kpi-container-fall' : 'kpi-container-grow']">
    <kpi v-for="kpi in kpis" :kpi_data="kpi" :key="kpi.id"></kpi>
  </div>
  <!-- component container END -->
</template>

<script>
// import NewItemModal from './NewItemModal'
import Kpi from './Kpi.vue';

export default {
  name: 'Kpicontainer',
  props: ['flex', 'area'],
  components: {
    Kpi
  },
  computed: {
    isGrow () {
      if (this.kpis.length > 3) {
        return true;
      }
    }
    // area () {
    //   return this.area
    // }
  },
  methods: {
    getKpis () {
      let data = {};
      if (this.area) {
        data['params'] = {'area': this.area};
      }
      this.$http.get('kpis/', data).then(response => {
        this.kpis = response.body.results;
      }
      );
    }
  },
  mounted () {
    this.getKpis();
  },
  data () {
    return {
      kpis: []
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Modules/Kpi/Kpicontainer.vue